import { Component, Input, OnInit } from '@angular/core';
import {
  AlertService,
  FileStoreService,
  IAlertType,
} from '../../../../_shared/services';
import { Components, Files } from '../../../../_shared/interfaces';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrModalModule } from "@clr/angular";
import { NgIf } from "@angular/common";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { UploadComponent } from "../../../../core/upload/upload.component";
import { TranslocoDirective } from "@jsverse/transloco";
import { ActivatedRoute } from "@angular/router";
import { getTenantStorage } from '../../../../_shared/utils/tenant-context';

import { ClarityIcons, timesCircleIcon } from "@cds/core/icon";
import { saveAs } from 'file-saver';
import { environment as env } from "../../../../../environments/environment";
import { filesBaseUrl } from "../../../../_shared/utils/rest-url";

@Component({
  selector: 'app-offer-details-documents',
  standalone: true,
  imports: [
    ClrDatagridModule,
    NgIf,
    ClrModalModule,
    NgxExtendedPdfViewerModule,
    UploadComponent,
    TranslocoDirective
  ],
  templateUrl: './offer-details-documents.component.html',
  styleUrl: './offer-details-documents.component.sass'
})
export class OfferDetailsDocumentsComponent implements OnInit {
  projectId: string = '';
  components: Components[] = [];
  offersFiles: Files[] = [];
  public showPdf = false;
  public showFileUpload = false;
  modalContent: string = '';
  modalUrl: string = '';
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  private filesDirectory = filesBaseUrl();

  @Input() offerNumber: number = 0;

  constructor(
    private alertDispatcher: AlertService,
    private fileService: FileStoreService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(timesCircleIcon)
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('prid') ?? '';
    this.getFilesSet([30], this.projectId);
  }

  showModal(fileId: string) {
    const phmToken = getTenantStorage('access_token');
    this.modalUrl = `${this.filesDirectory}/download_file?file_id=${fileId}&token=${phmToken}`;
    this.showPdf = true;
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
    this.loading = true;
    this.getFilesSet([30], this.projectId);
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  private getFilesSet(docType: number[], projectId: string) {
    this.fileService.getFilesSet(docType, projectId, 0, this.offerNumber).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.offersFiles = [];
          this.alertDispatcher.alertConfig.message = 'Keine Dateien gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.offersFiles = data.object;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return}
    })
  }

  deleteFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' wirklich löschen?\nDiese Aktion kann nicht rückgängig gemacht werden!')) {
      this.fileService.deleteFile(fileId)
        .subscribe({
          next: () => {
            this.offersFiles = this.offersFiles.filter(file => file.id !== fileId);
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde gelöscht. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
          },
          complete: () => {
            this.getFilesSet([30], this.projectId);
          },
          error: () => {
            return
          }
        })
    }
  }

  loadFile(fileId: string, fileName: string) {
    if (confirm('Wollen Sie die Datei ' + fileName + ' herunterladen?')) {
      this.fileService.downloadFile(fileId)
        .subscribe({
          next: data => {
            if (!data) {
              this.alertDispatcher.alertConfig.message = 'Keine Datei gefunden!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              return;
            }
            saveAs(data, fileName);
          },
          complete: () => {
            this.alertDispatcher.alertConfig.message = 'Datei ' + fileName + ' wurde heruntergeladen. ';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.INFO;
          },
          error: () => {
            return
          }
        })
    }
  }
}
